const subodinateInitialState = {};
export default (state = subodinateInitialState , action) => {
    switch(action.type){
        case "APP_LOADING":
            return{
                ...state,
                isLoading:action.isLoading
            };
        case "SET_SUBORDINATES":
            return{
                ...state,
                subordinates:action.subordinates,
            };
        default:
            return state 
    }
}